@if (showTitle) {
  <span class="font-bold text-2xl mb-5" translate>
    lingueopro.job.form.title
  </span>
}

<div class="w-full" translate>
  lingueopro.job.form.description
</div>

<div class="grid sm:grid-cols-3 gap-6 w-full mt-8" [formGroup]="businessForm">
  <div class="sm:col-span-3">
    <fuse-alert [appearance]="'outline'" [type]="'info'">
      <span translate>job.form.fuse.infoAlert</span>
    </fuse-alert>
  </div>

  <mat-radio-group class="invisible absolute w-0 h-0 pointer-events-none" [formControlName]="'job_situation'"
    #jobRadioGroup="matRadioGroup">
    @for (situation of job_situation_options; track trackByFn($index, situation)) {
      <mat-radio-button [value]="situation.value"></mat-radio-button>
    }
  </mat-radio-group>

  @for (situation of job_situation_options; track trackByFn($index, situation)) {
    <div class="relative flex flex-col items-start justify-start p-6 rounded-md shadow cursor-pointer bg-card"
      [ngClass]="{'ring ring-inset ring-primary':  businessForm.controls.job_situation.value === situation.value}"
      (click)="businessForm.controls.job_situation.setValue(situation.value)">
      <div class="font-medium" translate>{{ situation.label }}</div>
      <div class="flex-auto"></div>
    </div>
  }

  @if (businessForm.controls.job_situation.touched && businessForm.controls.job_situation.hasError('required')) {
    <mat-error translate>
      job.form.fuse.errorRequired
    </mat-error>
  }
</div>

@if (businessForm.controls.job_situation.value && businessForm.controls.job_situation.value!=='retired' && businessForm.controls.job_situation.value!=='student') {
  @if (jobRadioGroup.value=='unemployed') {
    <div class="mt-5 font-bold" translate>
      lingueopro.job.form.unemployedJob
    </div>
  }
  @if (jobRadioGroup.value=='employed') {
    <div class="mt-5 font-bold" translate>
      lingueopro.job.form.employedJob
    </div>
  }

  <div class="md:grid md:grid-cols-1 md:gap-4 mt-4">
    @if (jobs && !showJobSuggestionField && !suggestedJob) {
      <mat-form-field>
        <mat-icon class="icon-size-5 mr-2" matPrefix>search</mat-icon>
        <input #jobInput type="text" matInput [placeholder]="'job.form.fuse.jobPlaceholder' | translate"
          [formControl]="searchJobControl" [matAutocomplete]="autoJob"
          #jobAutocompleteTrigger="matAutocompleteTrigger"
          (blur)="onJobInputBlur()" />

        <mat-autocomplete #autoJob="matAutocomplete" [displayWith]="displayJob">
          @for (job of jobs; track job.id) {
            <mat-option [value]="job" (onSelectionChange)="selectJob(job, $event)">
              <span [innerHTML]="highlightMatch(job.name, searchJobControl.value)"></span>
            </mat-option>
          }
          @if (shouldInviteJobSuggestion() && !showJobSuggestionField) {
            <hr class="border-black my-2">
          }
          @if (shouldInviteJobSuggestion() && !showJobSuggestionField && (searchJobControl.value?.name || searchJobControl.value)) {
            <mat-option (onSelectionChange)="onJobSuggestOptionSelection($event)" class="bg-gray-200">
              <span translate>lingueopro.job.form.suggestButton </span> <span class="font-semibold">{{ (searchJobControl.value?.name || searchJobControl.value || '') }}</span>
            </mat-option>
          }
        </mat-autocomplete>
        
        @if (searchJobControl.touched && searchJobControl.hasError('required')) {
          <mat-error translate>
            niveau.form.error.required
          </mat-error>
        }
      </mat-form-field>
    }

    @if (suggestedJobControl.value || user.job_suggested) {
      <div class="flex flex-col mt-2">
        <div>
          <span translate>lingueopro.job.form.yourSuggestion.job</span> <span class="font-semibold">{{ suggestedJobControl.value || user.job_suggested }}</span>
        </div>
      </div>
    }
  </div>

  @if (jobRadioGroup.value=='unemployed') {
    <div class="font-bold mt-4" translate>
      lingueopro.job.form.unemployedSector
    </div>
  }
  @if (jobRadioGroup.value=='employed') {
    <div class="font-bold mt-4" translate>
      lingueopro.job.form.employedSector
    </div>
  }

  <div class="md:grid md:grid-cols-1 md:gap-4 mt-4">
    @if (businesses && !showBusinessSuggestionField && !suggestedBusiness) {
      <mat-form-field>
        <mat-icon class="icon-size-5 mr-2" matPrefix>search</mat-icon>
        <input #businessInput type="text" matInput [placeholder]="'job.form.fuse.businessPlaceholder' | translate"
          [formControl]="searchBusinessControl" [matAutocomplete]="autoBusiness"
          #businessAutocompleteTrigger="matAutocompleteTrigger"
          (blur)="onBusinessInputBlur()" />

        <mat-autocomplete #autoBusiness="matAutocomplete" [displayWith]="displayBusiness">
          @for (business of businesses; track business.id) {
            <mat-option [value]="business" (onSelectionChange)="selectBusiness(business, $event)">
              <span [innerHTML]="highlightMatch(business.name, searchBusinessControl.value)"></span>
            </mat-option>
          }
          @if (shouldInviteBusinessSuggestion() && !showBusinessSuggestionField) {
            <hr class="border-black my-2">
          }
          @if (shouldInviteBusinessSuggestion() && !showBusinessSuggestionField && (searchBusinessControl.value?.name || searchBusinessControl.value)) {
            <mat-option (onSelectionChange)="onBusinessSuggestOptionSelection($event)" class="bg-gray-200">
              <span translate>lingueopro.job.form.suggestButton </span> <span class="font-semibold">{{ (searchBusinessControl.value?.name || searchBusinessControl.value || '') }}</span>
            </mat-option>
          }
        </mat-autocomplete>
        
        @if (searchBusinessControl.touched && searchBusinessControl.hasError('required')) {
          <mat-error translate>
            niveau.form.error.required
          </mat-error>
        }
      </mat-form-field>
    }

    @if (suggestedBusinessControl.value || user.business_suggested) {
      <div class="flex flex-col mt-2">
        <div>
          <span translate>lingueopro.job.form.yourSuggestion.business</span> <span class="font-semibold">{{ suggestedBusinessControl.value || user.business_suggested }}</span>
        </div>
      </div>
    }
  </div>
}

@if (showButton) {
  <button mat-flat-button color="primary" class="mt-10"
    (click)="submit()" [disabled]="!canSubmit()">
    <span translate>{{ textButton }}</span>
  </button>
}